import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const SectionTitle = ({ title, description }) => (
  <Side>
    <Typography fontWeight={500} fontSize={18}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    )}
  </Side>
);

const KycOnline = ({ d }) => {
  return (
    <Row>
      <SectionTitle
        title="Online Presence"
        description="Website and social media links."
      />
      <Grid>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Website" value={d?.websiteLink || "-"} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="App Link" value={d?.appLink || "-"} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Facebook" value={d?.facebookUrl || "-"} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Instagram" value={d?.instagramUrl || "-"} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Twitter" value={d?.twitterUrl || "-"} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Uses Payment Link"
            value={d?.usePaymentLink ? "Yes" : "No"}
          />
        </Box>
      </Grid>
    </Row>
  );
};

export default KycOnline;
